import { useEffect, useState } from "react";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import ManufacturerAccordion from "./manufacturerAccordion";
import { useNavigate } from "react-router-dom";

import config from "../../Api/config";
import { DatabaseManufacturer } from "../../Api/Database";
import { useSession } from "../sessionProvider";
import { toast } from "react-toastify";


const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `2px solid rgba(0, 0, 0, 0.03)`,
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  }));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "2px solid rgba(0, 0, 0, 0.03)",
}));


export default function ManufacturerParentAccordion() {

    const navigate = useNavigate();
    const notifySuccess = (text:any) => toast.success(text,{theme:"colored"});
    const notifyError = (text:any) => toast.error(text,{theme:"colored"});

    const { ownerId } = useSession();
    const [expanded, setExpanded] = useState(false);
    const [manufacturers, setManufacturers] = useState<DatabaseManufacturer[]>([]);
    
    useEffect(() => {
        config.API.getManufacturers(ownerId, "","").then(mnfs => {
            //console.log(mnfs);
            setManufacturers(mnfs.results)
        }).catch(error => {
            console.error("Error in get manufacturer API: ", error);
            notifyError("Error in get manufacturer API: " + error);
        });
        
    }, []);

    const handleChange = () => () => {
      setExpanded(!expanded);
    };

    async function deleteManufacturer(id?: string): Promise<boolean> {
        if(id) {
            const index = manufacturers.findIndex((el) => {
                return el.id === id;
            })

            let delitedName = manufacturers[index].name;
            try {
                const deleted = await config.API.deleteManufacturer(ownerId, id);
                if(deleted) {
                    // successfully deleted on API, delete in state
                    setManufacturers((oldProducts) => {
                        oldProducts.splice(index, 1);
                        return oldProducts;
                    })
    
                    notifySuccess("Removed manufacturer '"+ delitedName +"'.");
                }
                return deleted;
            } catch(e: any) {
                if(JSON.stringify(e).includes("fk__item_manufacturer_id")){
                    notifyError("Can't delete manufacturer that have dpp's registered on.");
                }else{
                    notifyError(JSON.stringify(e));
                }
            };
        }
        return false;
    }
    
    return (
        <Accordion
            expanded={expanded}
            onChange={handleChange()}
            key={"api_settings"}
            sx={{ width: "100%" , marginTop:"20px", marginBottom:"20px"}}
            id={"api_settings"}
        >
            <MuiAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ minHeight: "38px" }}
            >
            <Typography sx={{ fontSize: "16px", fontWeight: "550" }}>
                Manufacturers
            </Typography>
            </MuiAccordionSummary>
            <AccordionDetails>
                <div>
                
                    {manufacturers.map((el:any, index:any) => {
                        return <ManufacturerAccordion key={"manufacturer"+index} manufacturer={el} delete={(): Promise<boolean> => {
                            return deleteManufacturer(el.id)
                        }}/>
                    })}
                    
                    <button className="btn btn-primary" style={{marginBottom:"0px"}} onClick={() =>{navigate("/register/manufacturer")}}> New manufacturer</button>
                </div>
            </AccordionDetails>
        </Accordion>
    )
}